/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_VehicleInputs */

const vi_trip_vehicle = /** @type {(inputs: Trip_VehicleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xe`)
};

/**

* @param {Trip_VehicleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_vehicle = /** @type {((inputs?: Trip_VehicleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_VehicleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_vehicle(inputs)
});